import { render, staticRenderFns } from "./BenevolentClassroom.vue?vue&type=template&id=0b483b68"
import script from "./BenevolentClassroom.vue?vue&type=script&lang=js"
export * from "./BenevolentClassroom.vue?vue&type=script&lang=js"
import style0 from "./BenevolentClassroom.vue?vue&type=style&index=0&id=0b483b68&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports